import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/sales/Dashboard";
import Leads from "@/pages/sales/Leads";
import Customers from "@/pages/sales/Customers";
import Dealers from "@/pages/sales/Dealers";
import Quotations from "@/pages/sales/Quotations";
import Orders from "@/pages/sales/Orders";
import Products from "@/pages/sales/Products";
import Inventory from "@/pages/sales/Inventory";
import Team from "@/pages/sales/Team";
import Visits from "@/pages/sales/Visits";
import Targets from "@/pages/sales/Targets";
import Collections from "@/pages/sales/Collections";
import Tasks from "@/pages/sales/Tasks";
import Expenses from "@/pages/sales/Expenses";
import Leave from "@/pages/sales/Leave";
import Reports from "@/pages/sales/Reports";
import Profile from "@/pages/sales/Profile";
import MfaSettings from "@/pages/settings/Mfa";

export default function SalesDashboard() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell variant="sales">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/dealers" element={<Dealers />} />
        <Route path="/quotations" element={<Quotations />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/products" element={<Products />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/team" element={<Team />} />
        <Route path="/visits" element={<Visits />} />
        <Route path="/targets" element={<Targets />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/leave" element={<Leave />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
